export default "__VITE_ASSET__81CbH68H__"